import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {BaseHttpService} from '../base.service';
import {SessionService} from '../session.service';


@Injectable()
export class ReportService extends BaseHttpService {

  private static reportPath = 'api/reports/';
  private static expertMonthlyReport = ReportService.reportPath + 'monthly_report/expert/';

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  getExpertMonthlyReport(workMonthId: number) {
    return this.httpGet(ReportService.expertMonthlyReport + workMonthId, 'blob', 'response');
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/report.service.ts